module.exports = __webpack_public_path__ + "static/treats_by_eunice_store-9555b5234df78612c7d6f4494963878a.jpg";